export default __webpack_public_path__ + "static/media/location-about-mobile.4d26f500.svg";